<template>
  <ParseForm :formParams='formParams' :reMountPage='reMountPage' ref='bus' :opCode='opCode'></ParseForm>
</template>

<script>
import ParseForm from '../../util/parseFormNew/ParseForm';

export default {
  name: 'U_DataBusiness',
  components: {
    ParseForm
  },
  props: [
    'formParams',
    'reMountPage',
    'opCode'
  ],
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
  },
};
</script>

<style scoped>

</style>
